import { render } from "./WordsForm.vue?vue&type=template&id=da058626&scoped=true&ts=true"
import script from "./WordsForm.vue?vue&type=script&lang=ts"
export * from "./WordsForm.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da058626"]])

export default __exports__